// Entradas creadas desde el mapa: viven en el borrador (mapa.tarifas_nuevas) y
// se crean al publicar. En el editor se usan como cualquier tarifa, con id
// negativo ("n3" es -3); al guardar, cada ubicación las nombra por clave.

export const esNueva = (id) => id < 0;
const idDe = (clave) => -Number(String(clave).slice(1));
const claveDe = (id) => `n${-id}`;

// colorJSON: el formato de color de las tarifas ({r,g,b,a} de 0 a 1)
export const colorJSON = (hex) => {
  const n = (i) => Math.round((parseInt(hex.slice(i, i + 2), 16) / 255) * 1000) / 1000;
  return JSON.stringify({ r: n(1), g: n(3), b: n(5), a: 1 });
};

// COLORES_ELEGIBLES: la paleta sin el violeta por defecto de las tarifas
// (#5656ff), que el mapa toma como "sin color elegido"
export const COLORES_ELEGIBLES = ["#6e56cf", "#00a884", "#ff8a00", "#e5484d", "#8e4ec6", "#0091ff", "#d4a017", "#30a46c"];

// colorLibre: el primer color que no usa otra entrada
export const colorLibre = (colores) => {
  const usados = new Set(Object.values(colores).map((c) => c.toLowerCase()));
  return COLORES_ELEGIBLES.find((c) => !usados.has(c.toLowerCase())) || COLORES_ELEGIBLES[Object.keys(colores).length % COLORES_ELEGIBLES.length];
};

// comoTarifa: la entrada nueva con la forma de las que vienen del servidor
export const comoTarifa = (t) => ({
  id: idDe(t.clave),
  concepto: t.concepto,
  precio: t.precio,
  color: t.color,
  fechas: t.fechas,
  inicio_venta: t.inicio_venta,
  fin_venta: t.fin_venta,
  venta_mesa: "silla",
  con_ventas: false,
  idubicacion: null,
  nueva: true,
});

const datosDe = (datos) => ({
  concepto: datos.concepto.trim(),
  precio: Number(datos.precio) || 0,
  color: datos.color,
  fechas: datos.fechas,
  inicio_venta: datos.inicio_venta,
  fin_venta: datos.fin_venta,
});

export const crearTarifaNueva = (mapa, datos) => {
  const actuales = mapa.tarifas_nuevas || [];
  const n = actuales.reduce((max, t) => Math.max(max, -idDe(t.clave)), 0) + 1;
  const clave = `n${n}`;
  return { mapa: { ...mapa, tarifas_nuevas: [...actuales, { clave, ...datosDe(datos) }] }, id: idDe(clave) };
};

export const editarTarifaNueva = (mapa, id, datos) => ({
  ...mapa,
  tarifas_nuevas: (mapa.tarifas_nuevas || []).map((t) => (t.clave === claveDe(id) ? { clave: t.clave, ...datosDe(datos) } : t)),
});

export const quitarTarifaNueva = (mapa, id) => ({
  ...mapa,
  tarifas_nuevas: (mapa.tarifas_nuevas || []).filter((t) => t.clave !== claveDe(id)),
  sectores: mapa.sectores.map((s) => (s.tarifas.includes(id) ? { ...s, tarifas: s.tarifas.filter((x) => x !== id) } : s)),
});

// al abrir: las claves de cada ubicación pasan a ids
export const desdeGuardado = (sector) => {
  const { tarifas_nuevas: claves, ...resto } = sector;
  return claves?.length ? { ...resto, tarifas: [...(resto.tarifas || []), ...claves.map(idDe)] } : resto;
};

// al guardar: los ids negativos de cada ubicación pasan a claves
export const paraGuardado = (sector) => {
  const nuevas = sector.tarifas.filter(esNueva);
  if (nuevas.length === 0) return sector;
  return { ...sector, tarifas: sector.tarifas.filter((t) => !esNueva(t)), tarifas_nuevas: nuevas.map(claveDe) };
};
